import { LayoutDashboard, Building2, ShieldCheck, Settings2, Circle, FileText, FolderKanban, Cog } from 'lucide-react';

export const headerMenus = [
  {
    id: 1,
    label: 'Group Dashboard',
    icon: LayoutDashboard,
    path: '/group-dashboard',
  },
  {
    id: 2,
    label: 'Executive Dashboard',
    icon: Building2,
    path: '/executive-dashboard',
  },
  {
    id: 3,
    label: 'Compliance',
    icon: ShieldCheck,
    path: '/compliance',
  },
  {
    id: 4,
    label: 'Control Management',
    icon: Settings2,
    path: '/control-management',
  },
  {
    id: 5,
    label: 'Risk Management',
    icon: Circle,
    path: '/risk-management',
  },
  {
    id: 6,
    label: 'Governance',
    icon: FileText,
    path: '/governance',
    sidebar: 'department',
  },
  {
    id: 7,
    label: 'Department',
    icon: FolderKanban,
    path: '/department',
    sidebar: 'department',
  },
  {
    id: 8,
    label: 'My Task',
    icon: Cog,
    path: '/tasks',
  },
];
